import { render, staticRenderFns } from "./UserIntegrationStatus.vue?vue&type=template&id=618eb0d5&"
import script from "./UserIntegrationStatus.vue?vue&type=script&lang=ts&"
export * from "./UserIntegrationStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports